import React from 'react';
import MediaPickerField from '../PageBuilder/SettingsPanel/FieldTypes/MediaPickerField';

/**
 * MediaField - Media picker field for the properties panel
 *
 * @param {Object} props
 * @param {Object} props.field - Field configuration
 * @param {string} props.field.key - Unique field identifier
 * @param {string} props.field.label - Display label
 * @param {string} [props.field.placeholder] - Placeholder text
 * @param {string} [props.field.acceptTypes] - Filter for media types ('all', 'image', 'video')
 * @param {string} [props.field.description] - Optional description text
 * @param {string} props.value - Current value (URL)
 * @param {Function} props.onChange - Callback when value changes
 * @param {boolean} [props.disabled] - Whether field is disabled
 * @param {string} [props.error] - Error message to display
 * @param {boolean} [props.compact] - Use compact inline layout
 */
export default function MediaField({ field, value, onChange, disabled = false, error, compact = false }) {
  // Compact mode: inline label + control
  if (compact) {
    return (
      <div className="py-0.5">
        <MediaPickerField
          value={value ?? ''}
          onChange={onChange}
          label={field.label}
          placeholder={field.placeholder}
          acceptTypes={field.acceptTypes || 'all'}
        />
        {error && (
          <p className="mt-1 text-xs text-red-500">{error}</p>
        )}
      </div>
    );
  }

  // Standard mode: stacked layout
  return (
    <div>
      <MediaPickerField
        value={value ?? ''}
        onChange={onChange}
        label={field.label}
        placeholder={field.placeholder}
        acceptTypes={field.acceptTypes || 'all'}
      />
      {field.description && (
        <p className="mt-1 text-xs text-gray-500">{field.description}</p>
      )}
      {error && (
        <p className="mt-1 text-xs text-red-500">{error}</p>
      )}
    </div>
  );
}
